import React, { useMemo } from "react";
import styles from "./index.module.scss";
import ChapterNode from "./components/ChapterNode";
import ChapterHeader from "./components/ChapterNode/components/ChapterHeader";
import { CourseChaptersInfo } from "API/courseware";
import { percent2Number } from "Utils/filter";
import useDeviceType from "Utils/useDeviceType";

interface ChaptersListProps {
    data: CourseChaptersInfo;
}

export default function ChaptersList({ data }: ChaptersListProps) {
    const { isPC } = useDeviceType();

    const percent = useMemo(
        () => percent2Number(data.learnProgress),
        [data.learnProgress]
    );

    const rootTitle = isPC ? (
        <ChapterHeader
            title={data.sourceChapter.chapterName}
            percent={percent}
        />
    ) : (
        data.sourceChapter.chapterName
    );

    return (
        <div className={styles.root}>
            <ChapterNode
                title={rootTitle}
                chapters={data.sourceChapter.children || []}
                sources={data.sourceChapter.dcCoursewareSourceList || []}
            />
        </div>
    );
}
